export const DOCTOLIB_APP_URL = process.env.REACT_APP_DOCTOLIB_APP_URL
